import { render, staticRenderFns } from "./PropertiesPanel.vue?vue&type=template&id=1f74d7d5&scoped=true&"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PropertiesPanel.vue?vue&type=style&index=1&id=1f74d7d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74d7d5",
  null
  
)

export default component.exports